import { restApiKey, table, viewId } from '../../../../_constants/Code'
import { PathInfoList } from '../../../../_constants/PathInfoList'
import { errorLog } from '../../../../common/logger/Logger'
import { getDynamoDB } from '../../../../common/utils/DynamoDbUtils'
import { ClientError } from '../../../../common/utils/Exception'
import { httpGet, httpPost } from '../../../../services/api/AmplifyApi'
import './types'
import { formatDate } from 'date-fns'

const API = restApiKey.CHROFY_REST_API

/**
 * @function _getSessionData Redux状態から最新情報を取得
 * @param {any} store
 * @returns {{
 *   corporationNumber: string
 *   userId: string
 *   userName: string
 *   corporationName: string
 * }}
 */
const _getSessionData = (store) => {
  const state = store.getState()
  return {
    corporationNumber: state.company.corporationNumber,
    userId: state.user.sub,
    userName: state.user.userName,
    corporationName: state.company.name
  }
}

/** @function fetchMaster マスター設定を取得 */
export async function fetchMaster(store) {
  const { corporationNumber, userId } = _getSessionData(store)
  try {
    const master = await getDynamoDB(table.Master, null, corporationNumber, {
      CorporationNumber: corporationNumber,
      MasterId: viewId.groupCompanyInfo
    })

    if (!master[0]) throw master

    return master[0]
  } catch (error) {
    console.error(error)
    errorLog('E000001', userId, viewId.groupCompanyInfo, 'fetchMaster', error)
  }
}

/** @function fetchGroupCompanyInfoList グループ会社情報を取得 */
export async function fetchGroupCompanyInfoList(store) {
  const { corporationNumber, userId } = _getSessionData(store)
  try {
    const init = {
      headers: {}
    }
    const groupCompanyInfo = await httpGet(
      restApiKey.CHROFY_REST_API,
      PathInfoList.Resource.getGroupCompanyInfo(corporationNumber),
      init
    )
    if (!groupCompanyInfo) throw groupCompanyInfo

    return groupCompanyInfo
  } catch (error) {
    console.error(error)
    errorLog('E000001', userId, viewId.groupCompanyInfo, 'fetchGroupCompanyInfoList', error)
    return []
  }
}

const formatDateYmd = (date) => formatDate(date, 'yyyy/MM/dd')

/**
 * @function preparePayload リクエストオブジェクトに変換
 * @param {TableData[]} payload
 */
const preparePayload = (store, payload) => {
  const { corporationNumber, corporationName, userName, userId } = _getSessionData(store)

  return {
    corporation_number: corporationNumber,
    corporation_name: corporationName,
    user_name: userName,
    user_sub: userId,
    table_data: payload.map((e) => {
      const validStartDate = e.validStartDate !== null ? formatDateYmd(e.validStartDate) : ''
      const validEndDate = e.validEndDate !== null ? formatDateYmd(e.validEndDate) : ''

      return {
        operation_type: e.operationType || '',
        key: e.key,
        comp_number: e.corporationNumber,
        comp_name: e.compName,
        comp_type: e.compType,
        valid_start_date: validStartDate,
        valid_end_date: validEndDate,
        memo: e.memo,
        display_order: Number(e.displayOrder)
      }
    })
  }
}

/**
 * @function updateGroupCompanyInfo データ更新
 * @param {TableData[]} payload
 */
export async function updateGroupCompanyInfo(store, payload) {
  const { corporationNumber } = _getSessionData(store)

  const init = {
    headers: {},
    body: preparePayload(store, payload)
  }

  const res = await httpPost(API, PathInfoList.Resource.updateGroupCompanyInfo(corporationNumber), init)

  if (!res) throw new ClientError('更新失敗', res)

  return res
}

export async function checkIfCorporationNumberInUse(store, corporationNumber) {
  return { inUse: false }

  const init = {
    headers: {}
  }
}
